module.exports = __webpack_public_path__ + "static/media/features_assesment.7686200c.svg";